module.exports = __webpack_public_path__ + "static/media/outlook-calendar.ad74269e.svg";